<template>
  <div class="job-card">
    <div
      class="jobs d-flex"
      style="justify-content: space-between;"
      @click="$emit('click', job)"
    >
      <div class="details-container" style="max-width: 500px;">
        <div class="company-name">{{ job.company }}</div>
        <div class="job-title">{{ job.job_title }}</div>
      </div>
      <div v-if="isJobScouted" class="scouted-badge">
        <div class="scouted-badge-text">スカウト<br />希望済</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "JobListItem",
  props: {
    job: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    isJobScouted: {
      type: Boolean,
      required: true,
    },
  },
};
</script>

<style scoped>
.job-card {
  background-color: white;
  border: 1px solid #e0e0e0;
  border-radius: 1px;
  padding: 16px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.job-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.company-name {
  font-weight: bold;
  font-size: 16px;
  color: #3c3c3c;
  font-weight: 600;
  margin-bottom: 8px;
}

.job-title {
  font-size: 14px;
  font-weight: 600;
  color: #3c3c3c;
}

.scouted-badge {
  margin: auto 0px;
}

.scouted-badge-text {
  width: 60px;
  border: 1px solid #f6ae2d;
  color: #f6ae2d;
  text-align: center;
  font-size: 10px;
}
</style>
